// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { headerStyles } from "@conklin/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import IconEdit from "@conklin/XDL/Icons/IconEdit";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import { createLinkIconStyles, hideElementOnPrint } from "@conklin/XDL/Utilities";
import DollarSign from "@insite/mobius/Icons/DollarSign";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        gap: 24px;
    `,
};
headerStyles.titleGridItem = {
    width: 12,
};

headerStyles.title = {
    variant: "h1",
    as: "h1",
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        menu: css`
            ${hideElementOnPrint}
        `,
    },
};

headerStyles.printLink = {
    ...createLinkIconStyles(IconPrint, "small"),
};

headerStyles.payLink = {
    ...createLinkIconStyles(DollarSign, "small", "left", false, {
        css: css`
            &&& {
                @media print {
                    display: none;
                }
            }
        `,
    }),
};

headerStyles.shareEntityButtonStyles = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.emailLink,
};

headerStyles.headerGridContainer = {
    gap: 0,
};
